module.exports = __webpack_public_path__ + "static/police-jl-c568877960c11295e703fffe671d2268.gif";